import React from 'react'
import { makeStyles, CircularProgress } from '@material-ui/core'
import moment from 'moment'

import UserAvatar from '../shared/UserAvatar'

const useStyles = makeStyles(theme => ({
  occurrences_root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    paddingBottom: 24
  },
  occurrence: {
    width: '100%',
    height: 'fit-content',
    borderRadius: 16,
    backgroundColor: '#F5F6F7',
    padding: 32
  },
  card_header: {
    display: 'flex',
    justifyContent: 'space-between',
    '& p': {
      margin: 0,
      fontWeight: 600,
      fontSize: 20,
      color: '#386093'
    }
  },
  avatar_wrapper: {
    marginTop: 24,
    display: 'flex',
    alignItems: 'center',
    columnGap: 8,
    '& .author': {
      fontWeight: 500,
      fontSize: 20,
      margin: 0
    }
  },
  answer: {
    fontWeight: 400,
    fontSize: 14,
    wordBreak: 'break-word'
  },
  empty_occurrences: {
    textAlign: 'center'
  }
}))

const OccurrencesView = ({ occurrences }) => {
  const classes = useStyles()
  if (occurrences.isFetching) return <CircularProgress />
  else if (occurrences.items.length === 0) {
    return (
      <p className={classes.empty_occurrences}>Nenhuma ocorrência cadastrada</p>
    )
  }
  return (
    <div className={classes.occurrences_root}>
      {occurrences.items.map(occurrence => {
        const classroom =
          occurrence.report_student.report.report_template.classroom?.[0]
        const occurrenceDate = moment(occurrence.created_at).format(
          'DD/MM/YYYY'
        )
        return (
          <div key={occurrence.id} className={classes.occurrence}>
            <div className={classes.card_header}>
              <p className='classroom'>{classroom.name}</p>
              <p className='date'>{occurrenceDate}</p>
            </div>
            <div className={classes.avatar_wrapper}>
              <UserAvatar
                withoutUserName
                avatarStyle={{ width: 56, height: 56 }}
                avatarUrl={occurrence?.user?.avatar_url}
                userName={occurrence?.user?.name}
              />
              <p className='author'>{occurrence?.user?.name}</p>
              {/* <p className='subject'>{pending_info}</p> */}
            </div>
            <p className={classes.answer}>{occurrence.answer}</p>
          </div>
        )
      })}
    </div>
  )
}

export default OccurrencesView
